import React from 'react';
import { Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';


const StockTypChip = (params) => {
    let color = 'primary';
    let label = "";
    switch (params.value) {
        case 'I':
            color = 'primary';
            label = "입고"
            break;
        case 'O':
            color = 'error';
            label = "출고"
            break;
        case 'D':
            color = 'default';
            label = "폐기"
            break;
        case 'A':
            color = 'warning';
            label = "조정"
            break;
        case 'M':
            color = 'secondary';
            label = "이동"
            break;

        default:
            color = 'default';
            break;
    }

    return (
        <Chip
            icon={<CircleIcon />}
            label={label}
            variant="outlined"
            color={color}
        />
    );
};

export default StockTypChip;
